module.exports = __webpack_public_path__ + "static/form-button-feedback-dont-6ace0c50494ea16d5ec2ad82d6de0ca6.png";